import { render, staticRenderFns } from "./wan.vue?vue&type=template&id=4f1988a4&scoped=true&"
import script from "./wan.vue?vue&type=script&lang=js&"
export * from "./wan.vue?vue&type=script&lang=js&"
import style0 from "./wan.vue?vue&type=style&index=0&id=4f1988a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1988a4",
  null
  
)

export default component.exports